import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';
import './messenger-links.css';

const CHANNELS = [
    { type: 'telegram', label: 'Telegram', icon: 'messenger-telegram.svg' },
    { type: 'max', label: 'Max', icon: 'messenger-max.svg' },
];

function channelOf(entry) {
    const name = String(entry.NAME || '').toLowerCase();
    const icon = String(entry.ICON || '').toLowerCase();
    if (icon === 'icon-tg' || name.includes('telegram') || name.includes('телеграм')) return 'telegram';
    if (icon === 'icon-max' || name === 'max' || name.includes('макс')) return 'max';
    return null;
}

function validLink(value) {
    try {
        const url = new URL(String(value || '').trim());
        return url.protocol === 'https:' ? url.href : null;
    } catch (_) {
        return null;
    }
}

/**
 * Ссылки задаются в инфоблоке 17 (menuMessengers), общем для шапки и подвала.
 * В списке только активные элементы; каналы без настроенной ссылки скрыты.
 */
export const MessengerLinks = {
    props: {
        variant: { type: String, default: 'floating' },
    },
    data() {
        return { nearPageEnd: false };
    },
    computed: {
        ...mapState(vplSiteStore, ['templateData']),
        messengers() {
            const entries = this.templateData && this.templateData.menuMessengers;
            return CHANNELS.map(channel => {
                const entry = Array.isArray(entries)
                    ? entries.find(item => channelOf(item) === channel.type && validLink(item.LINK))
                    : null;
                if (!entry) return null;
                return { ...channel, href: validLink(entry.LINK) };
            }).filter(Boolean);
        },
    },
    methods: {
        updateFloatingVisibility() {
            // SAIT-145: скрываем плавающие кнопки за 100 px до конца страницы — только
            // при ширине от 1200 px; на более узких экранах они видны всегда.
            if (!window.matchMedia('(min-width: 1200px)').matches) {
                this.nearPageEnd = false;
                return;
            }
            const page = document.scrollingElement || document.documentElement;
            const remaining = page.scrollHeight - window.innerHeight - page.scrollTop;
            this.nearPageEnd = remaining <= 100;
        },
    },
    mounted() {
        if (this.variant !== 'floating') return;

        this.updateFloatingVisibility();
        window.addEventListener('scroll', this.updateFloatingVisibility, { passive: true });
        window.addEventListener('resize', this.updateFloatingVisibility);

        // Высота меняется и без прокрутки: SPA-переходы, картинки и отложенные блоки.
        if (typeof ResizeObserver !== 'undefined') {
            this._messengersResizeObserver = new ResizeObserver(this.updateFloatingVisibility);
            this._messengersResizeObserver.observe(document.body);
            this._messengersResizeObserver.observe(document.documentElement);
        }
    },
    beforeUnmount() {
        if (this.variant !== 'floating') return;

        window.removeEventListener('scroll', this.updateFloatingVisibility);
        window.removeEventListener('resize', this.updateFloatingVisibility);
        if (this._messengersResizeObserver) this._messengersResizeObserver.disconnect();
    },
    template: `
        <nav v-if="messengers.length" v-show="variant !== 'floating' || !nearPageEnd" class="tas-messengers"
             :class="'tas-messengers--' + variant" aria-label="Связаться через мессенджер">
            <template v-for="messenger in messengers" :key="messenger.type">
                <a :class="variant === 'contacts' ? 'mob-contacts__social' : 'tas-messengers__link'"
                   :data-channel="messenger.type" :href="messenger.href" target="_blank"
                   :data-messenger-channel="messenger.type" :data-messenger-placement="variant"
                   rel="noopener noreferrer nofollow">
                    <span v-if="variant === 'contacts'" class="tas-messengers__contact-icon"
                          :style="{'--tas-messenger-icon': 'url(/local/templates/vpl_vue/img/svg/' + messenger.icon + ')'}"
                          aria-hidden="true"></span>
                    <img v-else :src="'/local/templates/vpl_vue/img/svg/' + messenger.icon"
                         alt="" aria-hidden="true">
                    <span>{{ variant === 'contacts'
                        ? 'Написать в ' + (messenger.type === 'max' ? 'MAX' : messenger.label)
                        : messenger.label }}</span>
                </a>
            </template>
        </nav>
    `,
};
